import { render, staticRenderFns } from "./MassButtonsHandler.vue?vue&type=template&id=4afee39a&scoped=true"
import script from "./MassButtonsHandler.vue?vue&type=script&lang=js"
export * from "./MassButtonsHandler.vue?vue&type=script&lang=js"
import style0 from "./MassButtonsHandler.vue?vue&type=style&index=0&id=4afee39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afee39a",
  null
  
)

export default component.exports